module.exports = __webpack_public_path__ + "static/media/arrowLeftFull.6bc70f9f.svg";